<script>
    import { fade } from 'svelte/transition';
    import './util/search';

    import Accordion from './components/accordion/accordion.svelte';
    import Alphabet from './components/alphabet/alphabet.svelte';
    import BusyOverlay from './components/busy-overlay.svelte';
    import Search from './components/search.svelte';

</script>

<div class="ghwp-faq" transition:fade>
    <BusyOverlay />
    <Search />
    <Alphabet />
    <Accordion />
</div>

<style>
    .ghwp-faq {
        position: relative;
        min-height: 50vh;
    }

</style>
